module.exports = __webpack_public_path__ + "img/logo2.f6fbdd7c.jpeg";